import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

export const heading2Command = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).toggleHeading({ level: 2 }).run()
    : editor.chain().focus().toggleHeading({ level: 2 }).run();

const Heading2 = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('heading', { level: 2 }) ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<div className="text-gray-800 text-xs font-weight-500">H2</div>}
      onClick={isExtension ? () => {} : () => heading2Command({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="HEADING_2" defaultMessage="Heading 2" />
        </div>
      )}
    </Button>
  );
};

export default Heading2;
